import React, { useEffect, useRef, useState } from "react";
import ListCard from "./ListCard";
import styles from "./ListView.module.css";
import {
  AllCardsGames,
  GroupedGameMap,
  ParentGames,
} from "../../../util/AllCardsGames";
import { useLocation } from "react-router-dom";
import JokerHorizontalList from "../../../components/JokerHorizontalList";
import TwoToneHorizontalSectionChild from "../../../components/TwoToneHorizontalSectionChild";
import { useTranslation } from "react-i18next";

interface Video {
  id: string | number;
  title: string;
  description: string;
  video_url: string;
  indicatorIcon: string;
  posterImg: string[];
  type: AllCardsGames;
}

interface ListViewProps {
  items: Array<Video>;
}

const ListView: React.FC<ListViewProps> = ({ items }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const itemRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  const [scrollTarget, setScrollTarget] = useState<AllCardsGames | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get("scrollTo") as AllCardsGames;

    if (!scrollTo) return;

    setScrollTarget(scrollTo);
  }, [location]);

  useEffect(() => {
    if (!scrollTarget) return;

    const el = itemRefs.current[scrollTarget];
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      setScrollTarget(null);
    }
  }, [scrollTarget]);

  return (
    <div className={styles.listContainer}>
      <div className={styles["lucky7"]}>
        <TwoToneHorizontalSectionChild
          titleTone1={t("joker_learn_page.lucky_7_title")}
          titleTone2={""}
          description={t("joker_learn_page.lucky_7_description")}
        >
          <JokerHorizontalList
            items={items.filter((item) =>
              GroupedGameMap[ParentGames.LUCKY_7].includes(item.type)
            )}
            isBlurEffectEnable={true}
            renderItem={(item: any) => (
              <div
                key={item.id}
                className={styles.cardWrapper}
                ref={(el) => {
                  if (el) {
                    itemRefs.current[item.type] = el;
                  }
                }}
              >
                <ListCard
                  title={item.title}
                  description={item.description}
                  videoUrl={item.video_url}
                  indicatorIcon={item.indicatorIcon}
                  posterImg={item.posterImg}
                />
              </div>
            )}
            showScrollbar={false}
          />
        </TwoToneHorizontalSectionChild>
      </div>
      <div className={styles["fourD-lotto"]}>
        <TwoToneHorizontalSectionChild
          titleTone1={t("joker_learn_page.lotto_4d_title")}
          titleTone2={""}
          description={t("joker_learn_page.lotto_4d_description")}
        >
          <JokerHorizontalList
            items={items.filter((item) =>
              GroupedGameMap[ParentGames.LOTTO_4D].includes(item.type)
            )}
            isBlurEffectEnable={true}
            renderItem={(item: any) => (
              <div
                key={item.id}
                className={styles.cardWrapper}
                ref={(el) => {
                  if (el) {
                    itemRefs.current[item.type] = el;
                  }
                }}
              >
                <ListCard
                  title={item.title}
                  description={item.description}
                  videoUrl={item.video_url}
                  indicatorIcon={item.indicatorIcon}
                  posterImg={item.posterImg}
                />
              </div>
            )}
            showScrollbar={false}
          />
        </TwoToneHorizontalSectionChild>
      </div>
    </div>
  );
};

export default ListView;
